var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"font-merriweather text-base sm:text-lg",class:{ 'p-5': !_vm.no_padding, 'p-1': _vm.no_padding }},[(_vm.block_data)?_c('span',[_vm._v(" "+_vm._s(_vm.block_data.text)+" ")]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }